<template>
    <div class="contenedor-principal-mapa">
        <div :id="idMapa" class="mapa"></div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import * as esri_geo from 'esri-leaflet-geocoder';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
   iconUrl: require('leaflet/dist/images/marker-icon.png'),
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    props: {
        idMapa: String,
        posicionOrigenMapa: Array,
        acercamientoInicialMapa: Number,
        colorZona: String,
        polygonoEditar: Array,
    },
    data() {
        return {
            map: null,
            agregar_marcador: false,
            marcadores: [],
            coordenadasPolygono: [],
            iniciarCordPolygono: false,
            polygonoTemporal: {},
            Polygonos: [],
            geocodeSearch: null,
            marcadorSeleccionado: null
        }
    },
    methods: {
        obtenerCoordenadasPorCalleParametros: function(datosDeDireccion) {
            this.eliminarMarcadorBusqueda();
            this.geocodeSearch.address(datosDeDireccion.calle).city(datosDeDireccion.ciudad).region(datosDeDireccion.region).postal(datosDeDireccion.codigoPostal).run( (err, results, response) => {
                if (err) {
                    console.log(err);
                    return;
                }
                if(results.results.length > 0) {
                    /* let posicion     = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                    let acercamiento = 19;
                    this.setViewMapa(posicion, acercamiento);
                    this.marcadorSeleccionado = L.marker(result.latlng);
                    this.marcadorSeleccionado.addTo(this.map).bindPopup(results.results[0].text).openPopup(); */
                }
                console.log(results);
            });
        },
        obtenerCoordenadasPorCalleCompleta: function({ calleCompleta, conMarcador = true, conEvento = true }) { debugger
            this.eliminarMarcadorBusqueda();
            let posicion = [];
            this.geocodeSearch.text(calleCompleta).run( (err, results, response) => {
                if (err) {
                    console.log(err);
                    return;
                }
                if(results.results.length > 0) {
                    posicion = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                    let acercamiento = 19;
                    this.map.setView(posicion, acercamiento);
                    if(conMarcador) {
                        this.marcadorSeleccionado = L.marker(results.results[0].latlng);
                        this.marcadorSeleccionado.addTo(this.map).bindPopup(results.results[0].text).openPopup();
                    } 
                }
                if(conEvento)
                    this.$emit('getCoordenadasBusquedaDireccion', posicion);
            }); 
        },
        actualizarMapa: function({ posicion }) { debugger
            this.map.setView(posicion, 19);
        },
        eliminarMarcadorBusqueda: function() {
            if(this.marcadorSeleccionado != null) {
                this.map.removeLayer(this.marcadorSeleccionado);
            }
        },
        setViewMapa: function(posicion, acercamiento) {
            if(this.map) {
                this.map.remove();
            }
            this.map = L.map(this.idMapa).setView(posicion, acercamiento);
            this.map.on('click', (e)=> { 
                this.eventoClickMapa(e);
            });
            L.tileLayer(enumeraciones.sinoj.mapas.google.googleStreets,{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3']}).addTo(this.map)
        },
        agregarMarcadores: function() {
            this.agregar_marcador = true;
            L.DomUtil.addClass(this.map._container, 'crosshair-cursor-enabled');
            this.$emit('agregarMarcador', this.agregar_marcador);
        },
        modoVisualizacion: function() {
            this.agregar_marcador = false;
            L.DomUtil.removeClass(this.map._container, 'crosshair-cursor-enabled');
            this.$emit('agregarMarcador', this.agregar_marcador);
        },
        eventoClickMapa: function(evento) {
            if(this.agregar_marcador) {
                const COORDENADAS = evento.latlng;
                this.agregarMarcador(COORDENADAS);
            }
        },
        agregarMarcador: function(coordenadas) { 
        /* opcion 1 =>  L.marker([coordenadas.lat,coordenadas.lng]).addTo(this.map); */
            let marcador = L.marker([coordenadas.lat,coordenadas.lng]);
            this.marcadores.push(marcador);
            this.map.addLayer(this.marcadores[this.marcadores.length -1]);
            this.coordenadasPolygono.push([coordenadas.lat,coordenadas.lng]);  
            this.agregarPolygono();
            this.iniciarCordPolygono = false;
            this.$emit('obtenerMarcadores', this.marcadores);
            this.$emit('obtenerCoordenadasPolygono', this.coordenadasPolygono);
        },
        agregarPolygono: function() {
            this.map.removeLayer(this.polygonoTemporal);
            this.polygonoTemporal = L.polygon(this.coordenadasPolygono, {color: this.colorZona}).addTo(this.map);
        },
        mostrarPoligonosAgregados: function(polygonos) {
            this.setViewMapa(this.posicionOrigenMapa,this.acercamientoInicialMapa);
            polygonos.forEach(p => {
                L.polygon(p.coordenadas, {color: p.color}).addTo(this.map);
            });
            //console.log('mostrarPoligonosAgregados::',polygonos);
        },
        asignarYmostrarPolygonosConMarcadores: function() { debugger
            this.polygonos = this.polygonoEditar;
            if(this.polygonos.length > 0) {
                /* this.colorZona = this.polygonos.color; */
                this.setViewMapa(this.posicionOrigenMapa,this.acercamientoInicialMapa);
                this.polygonos.forEach(p => {
                    p.coordenadas.forEach(m => {
                        let coordenada = {
                            lat: m[0],
                            lng: m[1]
                        }
                        this.agregarMarcador(coordenada);
                    });
                });
            }
        },
        eliminarMarcador: function() {
            if(this.marcadores.length > 0) {
                const INDEX_ULTIMO_MARCADOR = this.marcadores.length -1
                this.map.removeLayer(this.marcadores[INDEX_ULTIMO_MARCADOR]);
                this.marcadores.splice(INDEX_ULTIMO_MARCADOR,1);
                this.eliminarCoordenadaPolygono();
            }
            else {
                comun.mensajeDeAlerta('No hay ningun marcador agrgado', null, null);
            }
        },
        eliminarCoordenadaPolygono: function() {
            if(this.coordenadasPolygono.length > 0) {
                this.coordenadasPolygono.pop();
                this.agregarPolygono();
            }
            this.$emit('obtenerCoordenadasPolygono', this.coordenadasPolygono);
        },
        guardarNuevoPolygonZona: function() {
            let polygono = {coordenadas: this.coordenadasPolygono, color: this.colorZona};
            this.Polygonos.push(polygono);
            this.marcadores.forEach(m => {
                this.map.removeLayer(m);
            });
            this.Polygonos.forEach(p => {
                L.polygon(p.coordenadas, {color: p.color}).addTo(this.map);
            });
            /* let peticion = this.crearPeticionNuevaZona();
            this.guardarPolygonoDB(peticion);
            this.marcadores = [];
            this.coordenadasPolygono = [];
            this.eventoModoVisualizacion();
            this.mostrarFormulario = false; */
            this.$emit('obtenerPoligonos', this.Polygonos);
        },
        limpiarVariablesPolygonos: function() {
            this.marcadores = [];
            this.coordenadasPolygono = [];
            // despues de llamar this.mostrarFormulario = false;
            /* this.eventoModoVisualizacion();
            this.mostrarFormulario = false;
            this.$emit('obtenerMostrarFormulario', this.mostrarFormulario); */
        }
    },
    mounted() {  
        if(this.map) {
            this.map.remove();
        }   
        this.map = L.map(this.idMapa).setView(this.posicionOrigenMapa, this.acercamientoInicialMapa);
        this.map.on('click', (e)=> { 
            this.eventoClickMapa(e);
        });
        L.tileLayer(enumeraciones.sinoj.mapas.google.googleStreets,{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3']}).addTo(this.map);  
        if(this.polygonoEditar != null && this.polygonoEditar.length > 0) {
            this.asignarYmostrarPolygonosConMarcadores();
        } 

        this.geocodeSearch  = esri_geo.geocode();   
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
    }
}
</script>
<style scoped>
    .mapa {
        width: 100%;
        height: 100%;
    }

    .contenedor-principal-mapa {
        width: 100%;
        height: 100%;
    }

    .leaflet-container.crosshair-cursor-enabled {
        cursor: crosshair;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CMapaDePoligonos.vue